import { format, formatDistanceToNow, parseISO } from "date-fns";
import { id as idLocale } from "date-fns/locale";

export const rupiah = (n) => "Rp " + Math.round(n || 0).toLocaleString("id-ID");

export const fmtDate = (iso, pattern = "d MMM yyyy") => {
  if (!iso) return "-";
  try { return format(iso.length <= 10 ? parseISO(iso) : new Date(iso), pattern, { locale: idLocale }); } catch { return iso; }
};

export const fmtDateTime = (iso) => fmtDate(iso, "d MMM yyyy, HH:mm");

export const timeAgo = (iso) => {
  if (!iso) return "";
  try { return formatDistanceToNow(new Date(iso), { addSuffix: true, locale: idLocale }); } catch { return ""; }
};

export const STATUS_LABELS = {
  menunggu_bayar: "Menunggu Bayar",
  menunggu_konfirmasi: "Menunggu Konfirmasi",
  dijadwalkan: "Dijadwalkan",
  sedang_inspeksi: "Sedang Inspeksi",
  menunggu_review: "Menunggu Review",
  selesai: "Selesai",
  dibatalkan: "Dibatalkan",
};

export const STATUS_STYLES = {
  menunggu_bayar: "bg-amber-50 text-amber-600 border border-amber-200",
  menunggu_konfirmasi: "bg-orange-50 text-orange-600 border border-orange-200",
  dijadwalkan: "bg-blue-50 text-blue-600 border border-blue-200",
  sedang_inspeksi: "bg-violet-50 text-violet-600 border border-violet-200",
  menunggu_review: "bg-cyan-50 text-cyan-700 border border-cyan-200",
  selesai: "bg-emerald-50 text-emerald-600 border border-emerald-200",
  dibatalkan: "bg-red-50 text-red-500 border border-red-200",
};

export const VEHICLE_LABELS = { bekas: "Mobil Bekas", listrik: "Mobil Listrik", truk: "Truk", moge: "Motor Moge" };

export const CONDITION_META = {
  baik: { label: "Baik", cls: "bg-emerald-50 text-emerald-600 border-emerald-200" },
  perlu_perhatian: { label: "Perlu Perhatian", cls: "bg-amber-50 text-amber-600 border-amber-200" },
  rusak: { label: "Rusak", cls: "bg-red-50 text-red-500 border-red-200" },
  tidak_dicek: { label: "Tidak Dicek", cls: "bg-slate-50 text-slate-500 border-slate-200" },
};

export const RECOMMENDATION_META = {
  layak: { label: "Layak Dibeli", cls: "bg-emerald-600" },
  layak_dengan_catatan: { label: "Layak dengan Catatan", cls: "bg-amber-500" },
  tidak_layak: { label: "Tidak Direkomendasikan", cls: "bg-red-500" },
};

export const PAYMENT_LABELS = {
  pending: "Belum Dibayar", paid_held: "Ditahan (Escrow)", released: "Diteruskan ke Inspector",
  refunded: "Dikembalikan", failed: "Gagal", cancelled: "Dibatalkan",
};

export const PAYOUT_LABELS = { pending: "Menunggu", paid: "Dibayar", rejected: "Ditolak" };
export const PAYOUT_STYLES = {
  pending: "bg-amber-50 text-amber-600 border border-amber-200",
  paid: "bg-emerald-50 text-emerald-600 border border-emerald-200",
  rejected: "bg-red-50 text-red-500 border border-red-200",
};

export const ROLE_HOME = { pengguna: "/dashboard/pengguna", inspector: "/dashboard/inspector", admin: "/dashboard/admin" };
